export default __webpack_public_path__ + "static/_02_Miles-Smiles-cff18d3ddd1da04b6bcfefa81d76ae5a.svg";